import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import moment from "moment";
import useRequestIdGenerater from "customhooks";
import useTimeStamp from "reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp";
import axios from "axios";
import { dispatch } from "store";
import { openSnackbar } from "store/slices/snackbar";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";

import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";

import IconButton from "@mui/material/IconButton";

import { Box } from "@mui/system";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { useNavigate } from "react-router-dom";

import { EditOutlined, InfoOutlined } from "@mui/icons-material";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import PaymentAndInfo from "./PaymentAndInfo";

const EventPostDetailsCard = ({
  post,
  type = "All",
  setPosts,
  eventType,
  getEventDetails,
  handleCloseDetails,
  handleClickedDetails,
}) => {
  const formatDateTime = (date) => {
    // const dateTimeString = `${date} ${time}`;
    const formattedDateTime = moment(date).format("DD MMMM - YYYY");
    return formattedDateTime;
  };

  const stripHtmlTags = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const userId = localStorage.getItem("userId");
  const hasVolunteers = post?.eventAttendeesType?.Volunteers !== undefined;
  const hasParticipants = post?.eventAttendeesType?.Participants !== undefined;

  const [open, setOpen] = useState(false);
  const [openInfo, setOpenInfo] = useState(false);
  const [openforFees, setOpenForFees] = useState(false);
  const [joinAsVolunteer, setJoinAsVolunteer] = useState(false);
  const [joinAsParticipant, setJoinAsParticipant] = useState(false);
  const [alumniDetails, setAlumniDetails] = useState([]);
  const [paymentDetails, setPaymentDetails] = useState([]);

  const navigate = useNavigate();
  const ConvertToRequestId = useRequestIdGenerater();
  const { rendomRequestId, generateTimeStamp } = useTimeStamp();

  const [showAll, setShowAll] = useState(false);

  const handleShowMore = () => {
    setShowAll(!showAll);
  };

  const handleOpenForFees = () => {
    setOpenForFees(true);
    getEventFeeDetails();
  };

  const chipsToShow = showAll
    ? post?.eventForDetails
    : post?.eventForDetails?.slice(0, 2);

  const Tag = styled("div")(({ theme }) => ({
    backgroundColor: "#FFA000",
    color: "white",
    height: "24px",
    fontWeight: "bold",
    paddingLeft: "16px",
    paddingBottom: "4px",
    paddingRight: "16px",
    clipPath: "polygon(10% 0%, 100% 0%, 100% 100%, 10% 100%, 0% 0%)",
    marginLeft: "-8px",
  }));
  const currentDateTime = moment().format("DD/MM/YYYY hh:mm A");
  const handleJoinClick = (type) => {
    if (type === "participant" && post?.participantsFee) {
      setJoinAsParticipant(true);
      handleOpenForFees();
    } else {
      setJoinAsVolunteer(type === "volunteer");
      setJoinAsParticipant(type === "participant");
      setOpen(true); // open confirmation dialog
    }
  };

  const handleJoinAsParticipant = () => {
    // const volunteers = joinAsVolunteer;
    // const participants = joinAsParticipant;

    axios
      .get(
        `/v1/event/register?volunteers=${joinAsVolunteer}&Participants=${joinAsParticipant}&eventId=${
          post?.id
        }&alumniId=${localStorage.getItem("alumniId")}`,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem(
              "serviceToken",
            )}`,
            "Content-Type": "multipart/form-data",
            requestId: ConvertToRequestId(
              Math.floor(1000 + Math.random() * 9999),
              Math.floor(1000 + Math.random() * 9999) + rendomRequestId,
            ),
          },
        },
      )
      .then((response) => {
        dispatch(
          openSnackbar({
            open: true,
            message: "SuccessFully! Joined",
            variant: "alert",
            alert: {
              color: "success",
            },
            close: false,
          }),
        );
        getEventDetails(eventType);
        // setPosts(response?.data?.data);
        handleClose();
        generateTimeStamp();
      })
      .catch((error) => {
        generateTimeStamp();
        dispatch(
          openSnackbar({
            open: true,
            message: error.response.data.Msg,
            variant: "alert",
            alert: {
              color: "error",
            },
            close: false,
          }),
        );
      });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseOpenForFees = () => {
    setOpenForFees(false);
  };
  const handleOpenInfo = () => {
    setOpenInfo(true);
  };
  const handleCloseInfo = () => {
    setOpenInfo(false);
  };

  const getAlumniDetails = async () => {
    try {
      const response = await axios.get(
        `/v1/alumni/info?userId=${localStorage.getItem("userId")}`,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem(
              "serviceToken",
            )}`,
            "Content-Type": "application/json",
            requestId: ConvertToRequestId(
              Math.floor(1000 + Math.random() * 9999),
              Math.floor(1000 + Math.random() * 9999) + rendomRequestId,
            ),
          },
        },
      );
      setAlumniDetails(response?.data?.data);
      localStorage.setItem(
        "alumniBatchId",
        response?.data?.data?.batch?.id ?? "",
      );
      localStorage.setItem("alumniId", response?.data?.data?.id);
      generateTimeStamp();
    } catch (error) {
      generateTimeStamp();
      console.error("Failed to fetch data:", error);
    }
  };

  const date = moment(post?.startDate);
  const month = date.format("MMM");
  const day = date.format("DD");

  const handleEditNavigation = (id) => {
    navigate(`/edit/event/${id}`);
  };

  const getEventFeeDetails = () => {
    axios
      .get(`/v1/fee/event-fee?eventId=${post?.id}`, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem(
            "serviceToken",
          )}`,
          "Content-Type": "application/json",
          requestId: ConvertToRequestId(
            Math.floor(1000 + Math.random() * 9999),
            Math.floor(1000 + Math.random() * 9999) + rendomRequestId,
          ),
        },
      })
      .then((response) => {
        setPaymentDetails(response?.data?.data);
        generateTimeStamp();
      })
      .catch((error) => {
        generateTimeStamp();
      });
  };

  useEffect(() => {
    // getEventFeeDetails()
    getAlumniDetails();
  }, []);

  return (
    <>
      <div>
        <Card
          sx={{
            maxWidth: 460,
            borderRadius: "16px",
            overflow: "hidden",
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            boxShadow:
              "0 4px 20px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.1)",
            backgroundColor: "#fff",
            "&:hover": {
              transform: "translateY(-4px)",
              boxShadow: "0 6px 25px rgba(0, 0, 0, 0.12)",
            },
          }}
          variant="outlined"
        >
          {post?.binaryImage !== null ? (
            <CardMedia
              component="img"
              image={`data:image/*;base64, ${post?.binaryImage?.data}`}
              alt={post?.title}
              sx={{
                height: 200,
                width: "100%",
                objectFit: "cover",
                borderTopLeftRadius: "16px",
                borderTopRightRadius: "16px",
              }}
            />
          ) : (
            <CardMedia
              component="img"
              image={
                "https://www.fraction9coffee.com/cdn/shop/t/23/assets/placeholder_600x.png?v=11355573394622681665171454340"
              }
              alt={post?.title}
              sx={{
                height: 200,
                width: "100%",
                objectFit: "cover",
                borderTopLeftRadius: "16px",
                borderTopRightRadius: "16px",
              }}
            />
          )}

          <CardActions disableSpacing sx={{ mt: -2, mb: -2, mr: -3 }}>
            {post?.approvalStatus === "Pending" && (
              <IconButton>
                <EditOutlined onClick={() => handleEditNavigation(post?.id)} />
              </IconButton>
            )}

            <IconButton onClick={() => handleOpenInfo()} aria-label="info">
              <InfoOutlined color="secondary" />
            </IconButton>
            <Tag sx={{ ml: 1 }}>{post?.approvalStatus}</Tag>
          </CardActions>
          <CardContent sx={{ mt: -4 }}>
            <Grid container>
              <Grid item xs={12} md={12}>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ flexGrow: 1 }}
                >
                  {formatDateTime(post.startDate)}
                </Typography>
              </Grid>
              <Grid item md={10} xs={12}>
                <Typography
                  sx={{ cursor: "pointer" }}
                  onClick={() => handleClickedDetails(post?.id)}
                  variant="h3"
                >
                  {post?.title?.split(" ").slice(0, 2).join(" ") +
                    (post?.title.split(" ").length > 2 ? "..." : "")}
                </Typography>

                <Typography variant="body2" sx={{ mt: 1 }}>
                  {post?.eventCategories === null
                    ? post?.categoryName
                    : post?.eventCategories?.name}{" "}
                  ( {post?.eventType ?? ""})
                </Typography>
                <Typography variant="body2" sx={{ mt: 4 }}>
                  <a
                    href={post?.eventSpace ?? ""}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    {post?.eventSpace?.split(" ").slice(0, 10).join(" ") +
                      (post?.eventSpace.split(" ").length > 10 ? "..." : "")}
                  </a>
                </Typography>
              </Grid>
              <Grid item md={2} xs={12}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "70px",
                    width: "70px",
                    backgroundColor: "#2377dd",
                    borderRadius: "10px",
                    boxShadow: "rgba(0, 0, 0, 0.15) 0px 3px 3px 0px",
                    textAlign: "center",
                    color: "#fafafa",
                  }}
                >
                  <h4 style={{ margin: 0 }}>{month.toUpperCase()}</h4>
                  <h1 style={{ margin: 0 }}>{day}</h1>
                </div>
              </Grid>
            </Grid>

            <Grid
              item
              md={12}
              xs={12}
              sx={{ display: "flex", mt: 2, justifyContent: "flex-end" }}
            >
              {!post?.volunteersIds?.includes(userId) ? (
                <>
                  {hasVolunteers && (
                    <Chip
                      sx={{ cursor: "pointer" }}
                      color="primary"
                      variant="outlined"
                      disabled={new Date() > new Date(post?.endDate)}
                      label="Join as Volunteers"
                      onClick={() => handleJoinClick("volunteer")}
                    />
                  )}
                </>
              ) : (
                <Chip
                  color="primary"
                  variant="outlined"
                  disabled
                  label="Joined as Volunteers"
                />
              )}

              {!post?.participantIds?.includes(userId) ? (
                <>
                  {hasParticipants && (
                    <Grid sx={{ ml: hasVolunteers ? 1 : 0 }}>
                      <Chip
                        sx={{ cursor: "pointer" }}
                        color="primary"
                        variant="outlined"
                        disabled={new Date() > new Date(post?.endDate)}
                        label={
                          post?.participantsFee
                            ? `Join as Participant`
                            : "Join as Participant"
                        }
                        onClick={() => handleJoinClick("participant")}
                      />
                    </Grid>
                  )}
                </>
              ) : (
                <Grid sx={{ ml: 1 }}>
                  <Chip
                    color="primary"
                    variant="outlined"
                    disabled
                    label="Joined as Participants"
                  />
                </Grid>
              )}
            </Grid>

            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: 1,
                marginTop: "15px",
              }}
            >
              {chipsToShow?.map((data, index) => (
                <Chip key={index} size="small" label={data?.name} />
              ))}
              {post?.eventForDetails?.length > 2 && (
                <IconButton
                  size="small"
                  onClick={handleShowMore}
                  sx={{ padding: 0 }}
                >
                  {showAll ? (
                    <FirstPageIcon sx={{ color: "primary" }} />
                  ) : (
                    <LastPageIcon />
                  )}
                </IconButton>
              )}
            </Box>
          </CardContent>
        </Card>
      </div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to join as a{" "}
            {joinAsVolunteer ? "volunteer" : "participant"}?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            onClick={() => {
              handleJoinAsParticipant();
              handleClose();
            }}
            color="primary"
          >
            Join
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog sx={{ p: 0 }} open={openInfo} onClose={handleCloseInfo}>
        <DialogTitle sx={{ p: 0 }}>
          <Grid
            item
            md={12}
            xs={12}
            sx={{ display: "flex", p: 1, justifyContent: "space-between" }}
          >
            <Typography sx={{ ml: 1, fontWeight: 500, fontSize: "22px" }}>
              Instruction
            </Typography>
            <IconButton onClick={() => handleCloseInfo()}>
              <CloseOutlined />
            </IconButton>
          </Grid>
        </DialogTitle>
        <DialogContent sx={{ p: 2 }}>
          {stripHtmlTags(post?.instruction)}
        </DialogContent>
      </Dialog>
      <Dialog open={openforFees} onClose={handleCloseOpenForFees}>
        <DialogTitle>Payment Info</DialogTitle>
        <DialogContent>
          <PaymentAndInfo
            setJoinAsVolunteer={setJoinAsVolunteer}
            post={post}
            setJoinAsParticipant={setJoinAsParticipant}
            handleJoinAsParticipant={handleJoinAsParticipant}
            paymentDetails={paymentDetails}
            alumniDetails={alumniDetails}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default EventPostDetailsCard;
